import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AddToolsModel } from 'src/app/Models/addToolsModel';
import { GetToolsData } from 'src/app/Models/getToolsModel';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { ToolsComponentService } from 'src/app/services/tools-component.service';
import { OthersService } from '../competencies/others/othersDataService';
import { CompetenciesService } from '../competencies/competencies.service';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-tools-component',
  templateUrl: './tools-component.component.html',
  styleUrls: ['./tools-component.component.css']
})
export class ToolsComponentComponent implements OnInit {

  public toolValues: GetToolsData[];
  public masterData: GetToolsData[];
  public searchedRecords: GetToolsData[];
  public isDataFetched: boolean = false;
  public displayedColumns: string[] = ['name', 'toolTypeId', 'competency', 'subCompetency', 'sharepointURL', 'actions'];
  public dataSource: MatTableDataSource<GetToolsData>;
  public prepopulatedDataObject: AddToolsModel = new AddToolsModel;

  @Input() searchText: '';
  pageSize = 8;
  totalItems: number;
  currentPage = 1;
  public data: GetToolsData[];
  toolTypeId: number;
  compId: number;
  subCompId: number;
  competencyname: string;
  subCompetencyName: string;
  toolTypeName: string;
  placeholderText: string;


  constructor(
    private _service: ToolsComponentService,
    private router: Router,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private competencyService: CompetenciesService,
    public othersService: OthersService) { }
    @ViewChild(MatSort) sort: MatSort;


  ngOnInit() {
    
    this.othersService.selectedCompetencyID$.subscribe(res => {
      this.compId = res;
       if (this.compId== null || this.compId==0) {
          this.compId = Number(sessionStorage.getItem("compId"))       
        }
      this.othersService.id$.subscribe(res => {
        this.subCompId = res;
        if (this.subCompId== null||this.subCompId==0) {
          this.subCompId = Number(sessionStorage.getItem("SubcompId"))
        }
        this.getToolsFunction()
      })
    })
    this.competencyService.competencyName$.subscribe(x => { this.competencyname = x 
      if (this.competencyname== null||this.competencyname=="") {
        this.competencyname = sessionStorage.getItem("compTitle")
      }});
     this.othersService.name$.subscribe(name => {
      this.subCompetencyName = name;
      if (this.subCompetencyName== null||this.subCompetencyName== "") {
        this.subCompetencyName = sessionStorage.getItem("SubcompTitle")
      }
    })
  }



  getToolsFunctionSearch() {
    this.currentPage = 1;
    this.getToolsFunction();
  }

  getToolsFunction() {
    this.othersService.tooltypeid$.subscribe(value => {
      this.toolTypeId = value.value;
      this.toolTypeName = value.name;
      if (this.toolTypeId== null || this.toolTypeId==0) {
        this.toolTypeId = Number(sessionStorage.getItem("TooltypeId"))
      }
      if (this.toolTypeName== null || this.toolTypeName== '') {
        this.toolTypeName = sessionStorage.getItem("ToolTypename")
      }

    })
    this.placeholderText = "Search for " + this.toolTypeName + "...";


    this._service.getTools(this.compId, this.subCompId, this.toolTypeId).subscribe(res => {
      this.isDataFetched = true;
      this.toolValues = res;
      this.totalItems = this.toolValues.length;
      this.masterData = this.toolValues;
      this.data = this.toolValues.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
      this.dataSource = new MatTableDataSource(this.data)
      this.dataSource.sort = this.sort;


    })
  }

  searchResult() {
    if(this.searchText == ''){
      this.totalItems = this.masterData.length;
      this.data = this.masterData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
      this.dataSource = new MatTableDataSource(this.data);
      return
    }
    const res = this.dataSource.data
    if (this.searchText) {
      this.toolValues = this.masterData
      this.toolValues = this.toolValues.filter(obj => obj.name.toLowerCase().includes(this.searchText.toLowerCase()))
        .map(obj => obj);
      this.totalItems = this.toolValues.length;
    }
    else {
      this.totalItems = res.length;
    }
    if (this.toolValues.length > 0) {
      this.totalItems = this.masterData.length;
      this.data = this.toolValues.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
      this.dataSource = new MatTableDataSource(this.data)
      
    }
    else{
      setTimeout(() => {
        this.toastr.error("No data found", "", {timeOut: 1000});
      }); 
      this.dataSource = new MatTableDataSource(this.toolValues)
    }


  }
  addTools(toolTypeId, toolTypeName) {
    let result=null;
    this._service.setFormData(result);
    const sendData = {
      value: this.toolTypeId,
      name: this.toolTypeName,
    }
    this.subCompetencyName=this.subCompetencyName.replace(/\//g, '');
    this.subCompetencyName=this.subCompetencyName.split(' ').join('');
    this.router.navigate([`Home/CMF Portal/${this.competencyname}/${this.subCompetencyName}/Others/${sendData.name}/addTools`]);
      
  }

  onPageButtonClick(page: number): void {
    if (page !== this.currentPage) {
      this.currentPage = page;
      this.getToolsFunction();
    }
  }

  onPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.getToolsFunction();
    }
  }

  onNextPage(): void {
    const totalPages = this.getTotalPages();
    if (this.currentPage < totalPages) {
      this.currentPage++;
      this.getToolsFunction();
    }
  }

  getTotalPages(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }

  getPageNumbers(): number[] {
    const totalPages = this.getTotalPages();
    const visiblePages = Math.min(totalPages, 4); // Adjust the number of visible page buttons as needed
    const currentPageIndex = this.currentPage - 1;
    let startPageIndex: number;
    let endPageIndex: number;

    if (totalPages <= visiblePages) {
      startPageIndex = 0;
      endPageIndex = totalPages - 1;
    }
    else {
      const maxPagesBeforeCurrentPage = Math.floor(visiblePages / 2);
      const maxPagesAfterCurrentPage = Math.ceil(visiblePages / 2) - 1;
      if (currentPageIndex <= maxPagesBeforeCurrentPage) {
        // Current page is near the start
        startPageIndex = 0;
        endPageIndex = visiblePages - 1;
      }
      else if (currentPageIndex >= totalPages - 1 - maxPagesAfterCurrentPage) {
        // Current page is near the end
        startPageIndex = totalPages - visiblePages;
        endPageIndex = totalPages - 1;
      }
      else {
        // Current page is in the middle
        startPageIndex = currentPageIndex - maxPagesBeforeCurrentPage;
        endPageIndex = currentPageIndex + maxPagesAfterCurrentPage;
      }
    }
    return Array.from({ length: endPageIndex - startPageIndex + 1 }, (_, i) => startPageIndex + i + 1);
  }

  deleteTool(userId: string) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "400px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data === "DELETE") {
        this._service.deleteToolApiCall(userId).subscribe((res) => {
          setTimeout(() => {
            this.getToolsFunction();
          }, 1000);
        });
        this.toastr.success("Training deleted Successfully");
      }
    });
  }

  editFunction(id: number) {
    const sendData = {
      value: this.toolTypeId,
      name: this.toolTypeName
    }

    this._service.getId(id);
    this._service.getToolDetailsById().subscribe(
      (result) => {

        this.prepopulatedDataObject = result;
        this._service.setFormData(result);
        this._service.setCopyButtonStatus(false);
        this._service.setViewButtonStatus(false);
        this.subCompetencyName=this.subCompetencyName.replace(/\//g, '');
        this.subCompetencyName=this.subCompetencyName.split(' ').join('');
        this.router.navigate([`Home/Competencies/${this.competencyname}/${this.subCompetencyName}/Others/${sendData.name}/addTools`]);
      }
    )
       
  }

  copyFunction(id: number) {
    const sendData = {
      value: this.toolTypeId,
      name: this.toolTypeName
    }

    this._service.getId(id);
    this._service.getToolDetailsById().subscribe(
      (result) => {
        this.prepopulatedDataObject = result;
        this._service.setFormData(result);
        this._service.setCopyButtonStatus(true);
        this._service.setViewButtonStatus(false);
        this.subCompetencyName=this.subCompetencyName.replace(/\//g, '');
        this.subCompetencyName=this.subCompetencyName.split(' ').join('');
         this.router.navigate([`Home/Competencies/${this.competencyname}/${this.subCompetencyName}/Others/${sendData.name}/addTools`]);
      }
    )
   
  }


  viewFunction(id: number) {
    
    const sendData = {
      value: this.toolTypeId,
      name: this.toolTypeName
    }

    this._service.getId(id);
    this._service.getToolDetailsById().subscribe(
      (result) => {
        this.prepopulatedDataObject = result;
        this._service.setFormData(result);
        this._service.setViewButtonStatus(true);
        this.subCompetencyName=this.subCompetencyName.replace(/\//g, '');
        this.subCompetencyName=this.subCompetencyName.split(' ').join('');
        this.router.navigate([`Home/Competencies/${this.competencyname}/${this.subCompetencyName}/Others/${sendData.name}/addTools`]);
      }
    )
   }
}
